import { Container } from '@/components/container';
import { generalSettings } from '@/config';
import { KeenIcon } from '@/components';
import React from 'react';

interface FooterProps {
  onFeedbackClick: () => void;
}

const Footer: React.FC<FooterProps> = ({ onFeedbackClick }) => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <Container>
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-center gap-2 py-5">
          <div className="flex gap-2 font-normal text-2sm">
            <span className="text-gray-500">{currentYear} &copy;</span>
            <a
              href="https://www.bitflinx.com"
              target="_blank"
              className="text-gray-600 hover:text-primary"
            >
              BITFLINX - Florian Rocktäschel - für die Hettwer Metallbau GmbH
            </a>
          </div>
          <nav className="flex gap-2 font-normal text-2sm text-gray-600">
            <div className="flex justify-center mt-4">
              <button onClick={onFeedbackClick} type="button" className="btn btn-sm btn-primary">
                <KeenIcon icon="plus" /> Feedback geben
              </button>
            </div>
          </nav>
          {/*<nav className="flex gap-2 font-normal text-2sm text-gray-600">
            <a href={generalSettings.aboutLink} target="_blank" className="hover:text-primary">
              About
            </a>
            <a href={generalSettings.devsLink} target="_blank" className="hover:text-primary">
              Support
            </a>
            <a href={generalSettings.faqLink} target="_blank" className="hover:text-primary">
              FAQ
            </a>
            <a href={generalSettings.purchaseLink} target="_blank" className="hover:text-primary">
              Purchase
            </a>
          </nav>*/}
        </div>
      </Container>
    </footer>
  );
};

export { Footer };
